import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { SonyDocumentStatusBadge } from '@/Domain/components/KnowledgeBase/SonyDocumentStatusBadge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/Domain/components/Shared/Table/Table';
import { SonyAdminDocumentDto } from '@/UI/KnowledgeBase/SonyDocuments/SonyDocuments.dto';

interface SonyDocumentHistoryProps {
  rows: SonyAdminDocumentDto[];
  historyTotal: number;
}

export const SonyDocumentHistory = ({ rows, historyTotal }: SonyDocumentHistoryProps) => {
  const { t } = useTranslation('sony_admin');

  return (
    <section className="space-y-2">
      <h2 className="text-sm font-semibold text-foreground">{t('sheet.history_section')}</h2>
      <div className="overflow-x-auto rounded-xl border border-border">
        <Table data-testid="sony-history-table">
          <TableHeader className="bg-accent">
            <TableRow>
              {(['status', 'version', 'version_timestamp', 'retrain_id', 'updated'] as const).map(
                (column) => (
                  <TableHead
                    key={column}
                    className="whitespace-nowrap bg-accent text-sm font-medium text-muted-foreground"
                  >
                    {t(`sheet.history.${column}`)}
                  </TableHead>
                ),
              )}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  <SonyDocumentStatusBadge status={row.status} />
                </TableCell>
                <TableCell className="whitespace-nowrap text-sm tabular-nums text-muted-foreground">
                  {row.version}
                </TableCell>
                <TableCell className="whitespace-nowrap text-sm tabular-nums text-muted-foreground">
                  {row.version_timestamp ?? ''}
                </TableCell>
                <TableCell className="whitespace-nowrap text-sm tabular-nums text-muted-foreground">
                  {row.retrain_id ?? ''}
                </TableCell>
                <TableCell className="whitespace-nowrap text-sm text-muted-foreground">
                  {format(new Date(row.last_updated_timestamp), 'MMM d, yyyy HH:mm')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {historyTotal > rows.length && (
        <div className="text-sm text-muted-foreground" data-testid="sony-history-showing">
          {t('sheet.history_showing', { shown: rows.length, count: historyTotal })}
        </div>
      )}
    </section>
  );
};
